var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#9C8831"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 13.1734C19.5 13.7257 19.0523 14.1734 18.5 14.1734H14.1626V18.5C14.1626 19.0523 13.7149 19.5 13.1626 19.5H12.8374C12.2851 19.5 11.8374 19.0523 11.8374 18.5V14.1734H7.5C6.94771 14.1734 6.5 13.7257 6.5 13.1734V12.8266C6.5 12.2743 6.94772 11.8266 7.5 11.8266H11.8374V7.5C11.8374 6.94772 12.2851 6.5 12.8374 6.5H13.1626C13.7149 6.5 14.1626 6.94772 14.1626 7.5V11.8266H18.5C19.0523 11.8266 19.5 12.2743 19.5 12.8266V13.1734Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.acf5c1cae82bb88ef4bd49ba25fcd3d5.svg";
export { ForwardRef as ReactComponent };